import { useEffect } from "react";
import { CallCallStatus } from "../api/graphql";

interface UseCallPollingOptions {
  call: { url?: string | null; callStatus: CallCallStatus } | null | undefined;
  refetch: () => void;
  intervalMs?: number;
}

// poll for meeting information. mostly useful for on-demand meetings but
// also for incidents where CVH doesn't start on time.
// eslint-disable-next-line import/prefer-default-export
export function useCallPolling({
  call,
  refetch,
  intervalMs = 30000,
}: UseCallPollingOptions) {
  useEffect(() => {
    const callIsJoinable = !!call?.url;
    const callHasEnded = call && call.callStatus === CallCallStatus.Ended;
    if (!call || callIsJoinable || callHasEnded) return () => {};

    const timer = setInterval(refetch, intervalMs);
    return () => clearInterval(timer);
  }, [call, refetch, intervalMs]);
}
